import { createContext } from "react";
export const OverflowContext = /*#__PURE__*/createContext();